<template>
  <fts-design-modal
    full-screen
    title="Import"
    desc="import data"
    class="fts-import"
    ref="ftsDesignModal">
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title with-hint" v-if="moduleId">
        <div class="design-modal-header-name import-header-name">Import for</div>
        <fts-moji
          :emoji="module.emoji"
          class="design-modal-header-emoji"
          v-if="module.emoji"
        />
        <div class="design-modal-header-name">{{module.name}}</div>
      </div>
    </template>
    <!-- body -->
    <template #body>
      <fts-import-designer
        :vector-id="moduleId"
        :form-data="moduleImport"
        :user-import="true"
        @import:success="importSuccess"
        ref="importDesigner"
      />
    </template>
    <!-- footer right -->
    <template #footerRight>
      <fts-btn text @click="close">Cancel</fts-btn>

      <fts-btn
        text
        color="primary"
        @click="$refs.importDesigner.import()"
      >
        <font-awesome-icon :icon="['fas', 'file-upload']" /> Import
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import { clientStore } from "../store/clientStore"

import FTSDesignModal from '../design/FTSDesignModal';
import FTSImportDesigner from "../design/FTSImportDesigner";
import FTSBtn from "./FTSBtn";
import FTSMoji from "./FTSMoji";

export default {  
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-import-designer": FTSImportDesigner,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
  },
  props: {
    moduleId: Number,
    moduleImport: Object
  },
  methods: {
    open() {
      this.$refs.ftsDesignModal.show();
    },
    close() {
      this.$refs.ftsDesignModal.close();
    },
    importSuccess() {
      this.$emit('importDone');
      this.close();
    },
  },
  computed: {
    module() {
      return clientStore.state.workspace.vectors.find(
        (x) => x.id == this.moduleId
      );
    },
  }
}
</script>

<style lang="scss" scoped>
.fts-import {
  .import-header-name {
    flex-shrink: 0;
  }
}
</style>